var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","scrollable":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticStyle:{"height":"100%","display":"flex","flex-direction":"column"}},[_c('v-card-title',{staticClass:"d-flex align-center justify-space-between"},[_c('span',[_vm._v("Preview Perencanaan")]),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_c('v-card-text',{staticStyle:{"flex":"1","overflow":"hidden","padding":"0"}},[_c('PerencanaanTable',{attrs:{"height":"80vh","planningList":_vm.planningList,"loading":_vm.loading,"stoppingItem":_vm.stoppingItem,"deletingItem":_vm.deletingItem,"verifyingItem":_vm.verifyingItem,"readonly":_vm.readonly,"canCopy":_vm.canCopy},on:{"editPlanning":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'editPlanning' ].concat( args ));
},"salinPlanning":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'salinPlanning' ].concat( args ));
},"movePlanningUp":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'movePlanningUp' ].concat( args ));
},"movePlanningDown":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'movePlanningDown' ].concat( args ));
},"stopPlanning":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'stopPlanning' ].concat( args ));
},"resumePlanning":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'resumePlanning' ].concat( args ));
},"deletePlanning":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'deletePlanning' ].concat( args ));
},"verifyPlanning":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'verifyPlanning' ].concat( args ));
},"addToImplementation":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.$emit.apply(void 0, [ 'addToImplementation' ].concat( args ));
}}})],1),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Tutup")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }